import { FC, JSX, useContext, useMemo } from "react";
import { UiStatisticsCollapseContext } from "../contexts/UiStatisticsCollapseContext";
import { QESButton } from "@app/shared/qes-standards";

interface CollapseProps {
  graphs: JSX.Element[];
  onOpen?: () => void;
  title: string;
}

/**
 * A custom "accordion" that removes its children from the DOM when closed. This is done intentionally to prevent excessive network calls from the iframe children.
 * @param props
 */
export const UiStatisticsCollapse: FC<React.PropsWithChildren<CollapseProps>> = (props: CollapseProps) => {
  const { collapseCategory, expandCategory, expandedCategories } = useContext(UiStatisticsCollapseContext);

  const isOpen = useMemo(() => {
    return expandedCategories.includes(props.title);
  }, [expandedCategories]);

  const handleClick = () => {
    if (isOpen) {
      collapseCategory(props.title);
    } else {
      expandCategory(props.title);
      props.onOpen && props.onOpen();
    }
  }

  const arrowClass = useMemo(() => {
    return isOpen ? "fa-chevron-down" : "fa-chevron-right";
  }, [isOpen]);

  return (
    <section id={props.title}>
      <QESButton qesType="secondary" className="pt-1 pb-1 pl-2 text-dark" onClick={handleClick} aria-pressed={isOpen} qesTestId={`ui-statistics-collapse__toggle--${props.title}`}>
        <i className={`fa ${arrowClass}`} /> <span>{props.title}</span>
      </QESButton>
      <div>
        {isOpen && props.graphs}
      </div>
    </section>
  )
}